import React, { CSSProperties } from 'react';

import { NorPagenationItem, ActPagenationItem, PagenationPrev, PagenationFirst } from './Common';
import images from '../assets';
import { MediaQuery } from './Common';
class Pagenation extends React.Component {
  render() {
    const { total_pages, getList } = this.props;
    let { page } = this.props;

    const pageNumber = [];
    const mobilePageNumber = [];
    var i;

    if (typeof page !== 'number') {
      page = Number(page);
    }

    if (page > 5) {
      for (i = page - 4; i <= page + 5; i++) {
        pageNumber.push(i);
        if (i >= total_pages) break;
      }
    } else {
      for (i = 1; i <= total_pages; i++) {
        pageNumber.push(i);
        if (i > 9) break;
      }
    }

    if (page === total_pages && page > 2) {
      for (i = page - 2; i <= page; i++) {
        mobilePageNumber.push(i);
      }
    } else if (page > 1) {
      for (i = page - 1; i <= page + 1; i++) {
        mobilePageNumber.push(i);
        if (i === total_pages) break;
      }
    } else if (total_pages === 1) {
      mobilePageNumber.push(1);
    } else {
      for (i = page; i <= page + 2; i++) {
        mobilePageNumber.push(i);
        if (i === total_pages) break;
      }
    }
    if (total_pages > 0) {
      return (
        <div style={rootstyle}>
          <PagenationFirst onClick={() => getList(1)}>
            <img alt="" src={images.icon_pagefirst} style={{ width: 15, height: 'auto' }} />
          </PagenationFirst>
          <PagenationPrev
            onClick={() => {
              if (page !== 1) getList(page - 1);
            }}
          >
            <img alt="" src={images.icon_pageprev} style={{ width: 15, height: 'auto' }} />
          </PagenationPrev>
          <MediaQuery max={799}>
            {mobilePageNumber.map((item) => {
              if (item === page)
                return (
                  <ActPagenationItem key={item} onClick={() => getList(item)}>
                    {item}
                  </ActPagenationItem>
                );
              return (
                <NorPagenationItem key={item} onClick={() => getList(item)}>
                  {item}
                </NorPagenationItem>
              );
            })}
          </MediaQuery>
          <MediaQuery min={800}>
            {pageNumber.map((item) => {
              if (item === page)
                return (
                  <ActPagenationItem key={item} onClick={() => getList(item)}>
                    {item}
                  </ActPagenationItem>
                );
              return (
                <NorPagenationItem key={item} onClick={() => getList(item)}>
                  {item}
                </NorPagenationItem>
              );
            })}
          </MediaQuery>
          <PagenationPrev
            onClick={() => {
              if (page !== total_pages) getList(page + 1);
            }}
          >
            <img alt="" src={images.icon_pagenext} style={{ width: 15, height: 'auto' }} />
          </PagenationPrev>
          <PagenationFirst onClick={() => getList(total_pages)}>
            <img alt="" src={images.icon_pagelast} style={{ width: 15, height: 'auto' }} />
          </PagenationFirst>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

const rootstyle = {
  display: 'flex',
  alignItems: 'center',
};
export default Pagenation;
